import { render, staticRenderFns } from "./GroupSettingsEdit.vue?vue&type=template&id=4602bd0c&scoped=true&"
import script from "./GroupSettingsEdit.vue?vue&type=script&lang=js&"
export * from "./GroupSettingsEdit.vue?vue&type=script&lang=js&"
import style0 from "./GroupSettingsEdit.vue?vue&type=style&index=0&id=4602bd0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4602bd0c",
  null
  
)

export default component.exports